import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { PdpRespBreadcrumbs } from '../PdpRespBreadcrumbs/PdpRespBreadcrumbs';
import { PdpRespSimilarItemsGrid } from '../PdpRespSimilarItems/PdpRespSimilarItemsGrid';
import { PdpRespSeoLinks } from '../PdpRespSeoLinks/PdpRespSeoLinks';
import { PdpRespNotListedContent } from '../PdpRespNotListedContent/PdpRespNotListedContent';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';
import { SIMILAR_ITEMS_LIST } from '../tracking/similarItemsTracking';

// messages
import { youMayAlsoLike } from '../pdpMessages';

import styles from './PdpRespContainerNotListed.scss';

export const PdpRespContainerNotListedComponent = props => {
    const { item, user, similarGridItems, relayVariables, viewer, currency } = props;

    return (
        <Fragment>
            {/* Breadcrumbs */}
            <PdpRespBreadcrumbs item={item} />

            {/* Not Listed Main Content: Title and Follow Button */}
            <PdpRespNotListedContent item={item} user={user} />

            {/* You May Also Like */}
            <div className={styles.similar}>
                <PdpRespSimilarItemsGrid
                    header={youMayAlsoLike}
                    relayVariables={{
                        userId: relayVariables.userId,
                        isClient: relayVariables.isClient,
                    }}
                    item={item}
                    similarItems={
                        similarGridItems ? similarGridItems.edges.map(({ node }) => node) : null
                    }
                    isDark={false}
                    viewer={viewer}
                    currency={currency}
                    user={user}
                    showLightBox={false}
                    favoritesLocation={locations.SIMILAR_ITEM_GRID}
                    gridLocation={SIMILAR_ITEMS_LIST}
                />
            </div>

            {/* More Ways To Browse */}
            <PdpRespSeoLinks viewer={viewer} item={item} />
        </Fragment>
    );
};

PdpRespContainerNotListedComponent.propTypes = {
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    relayVariables: PropTypes.shape({
        userId: PropTypes.string,
        isClient: PropTypes.bool.isRequired,
    }).isRequired,
    similarGridItems: PropTypes.object.isRequired,
    currency: PropTypes.string,
};

export const PdpRespContainerNotListed = createFragmentContainer(
    PdpRespContainerNotListedComponent,
    {
        viewer: graphql`
            fragment PdpRespContainerNotListed_viewer on Viewer {
                ...PdpRespSimilarItemsGrid_viewer
                ...PdpRespSeoLinks_viewer
            }
        `,
        item: graphql`
            fragment PdpRespContainerNotListed_item on Item {
                ...PdpRespBreadcrumbs_item
                ...PdpRespTitle_item
                ...PdpRespSeoLinks_item
                ...PdpRespNotListedContent_item
            }
        `,
        user: graphql`
            fragment PdpRespContainerNotListed_user on User {
                ...PdpRespSimilarItemsGrid_user
                ...PdpRespNotListedContent_user
            }
        `,
        similarGridItems: graphql`
            fragment PdpRespContainerNotListed_similarGridItems on moreLikeThisConnection {
                edges {
                    node {
                        ...PdpRespSimilarItemsGrid_similarItems
                    }
                }
            }
        `,
    }
);
